import script from "./DepartmentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./DepartmentModal.vue?vue&type=script&setup=true&lang=js"

import "./DepartmentModal.vue?vue&type=style&index=0&id=75f89f38&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75f89f38"]])

export default __exports__